import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "active", "theme"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { Filter } from "../icons";
import { ButtonBase } from "../internal/ButtonBase";
import styles from './TableFilterButton.css';
var cx = classNames.bind(styles);
export var TableFilterButton = /*#__PURE__*/forwardRef(function TableFilterButton(_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      active = _ref.active,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, props, {
    ref: ref,
    className: cx('root_component', "theme_".concat(theme), classes.root)
  }), active && /*#__PURE__*/React.createElement("span", {
    className: cx('point')
  }), /*#__PURE__*/React.createElement(Filter, {
    size: "md"
  }));
});